import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackendToastrService {
  public cartCountSubject = new Subject<string>();
  cartCount$ = this.cartCountSubject.asObservable();
}
